<template>
  <router-view />
</template>

<script setup>
import { useSeoMeta } from "@vueuse/head";
useSeoMeta({
  title: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  description: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  ogDescription: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
  ogTitle: "WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska",
});
</script>
